import { CORE_QUOTE_DETAILS_QUERY_RESET } from '~/redux-modules/query-refactor/constants'

import {
    CONFIGURATION_TAB_QUERY_FAILURE,
    CONFIGURATION_TAB_QUERY_SUCCESS,
    SET_QUOTE_DETAILS_PAGE_LOADING,
    CORE_QUOTE_DETAILS_QUERY_SUCCESS,
    CORE_QUOTE_DETAILS_QUERY_FAILURE,
    LEGACY_QUOTE_DETAILS_QUERY_FAILURE,
    LEGACY_QUOTE_DETAILS_QUERY_LOADING,
    IM_FEEDBACK_ADDREQ_UNCONFIGUREDCONFIGMODAL_TABS_QUERY_FAILURE,
    IM_FEEDBACK_ADDREQ_UNCONFIGUREDCONFIGMODAL_TABS_QUERY_SUCCESS,
    CONFIG_MODAL_THREAD_FEEDBACK_ADD_REQ_QUERY_SUCCESS,
    CONFIG_MODAL_THREAD_FEEDBACK_ADD_REQ_QUERY_FAILURE,
    DRAWING_ANALYSIS_TAB_QUERY_SUCCESS,
    DRAWING_ANALYSIS_TAB_QUERY_FAILURE,
} from './constants'
import {
    INITIAL_STATE_TYPE,
    ConfigurationTabFailureAction,
    ConfigurationTabSuccessAction,
    QuoteDetailsPageActions,
    CoreQuoteDetailsSuccessAction,
    CoreQuoteDetailsFailureAction,
    SetLegacyQuoteDetailsQueryLoadingAction,
    LegacyQuoteDetailsQueryFailureAction,
    IMFeedbackAddReqUnconfiguredConfigModalFailureAction,
    IMFeedbackAddReqUnconfiguredConfigModalSuccessAction,
    ConfigTabForFeedbackThreadsAddReqModalSuccessAction,
    ConfigTabForFeedbackThreadsAddReqModalFailureAction,
    drawingAnalysisTabFailureAction,
    drawingAnalysisTabSuccessAction,
} from './types'

export const INITIAL_STATE: INITIAL_STATE_TYPE = {
    configurationTabQuery: {
        configurationTabData: null,
        errorMessage: null,
    },
    coreQuoteDetails: {
        coreQuoteDetailsData: null,
        errorMessage: null,
    },
    detailsForIMFeedbackAddReqUnconfiguredConfigModalTabs: {
        detailsForIMFeedbackAddReqUnconfiguredConfigModalTabsData: null,
        errorMessage: null,
    },
    legacyQuoteDetails: {
        errorMessage: null,
    },
    drawingAnalysisQuery: {
        drawingAnalysisTabData: null,
        errorMessage: null,
    },
    detailsForFeedbackThreadsAddReqModalConfigTab: {
        detailsForFeedbackThreadsAddReqModalConfigTabData: null,
        errorMessage: null,
    },
    loading: false,
    error: false,
}

export const reducer = (
    state = INITIAL_STATE,
    action: QuoteDetailsPageActions,
) => {
    switch (action.type) {
        case SET_QUOTE_DETAILS_PAGE_LOADING: {
            return {
                ...state,
                loading: true,
            }
        }
        case CONFIGURATION_TAB_QUERY_SUCCESS: {
            const castAction = action as ConfigurationTabSuccessAction

            return {
                ...state,
                configurationTabQuery: {
                    configurationTabData: castAction.quote,
                    errorMessage: null,
                },
                loading: false,
                error: false,
            }
        }
        case CONFIGURATION_TAB_QUERY_FAILURE: {
            const castAction = action as ConfigurationTabFailureAction

            return {
                ...state,
                configurationTabQuery: {
                    configurationTabData: null,
                    errorMessage: castAction.errorMessage,
                },
                loading: false,
                error: true,
            }
        }
        case CORE_QUOTE_DETAILS_QUERY_FAILURE: {
            const castAction = action as CoreQuoteDetailsFailureAction

            return {
                ...state,
                coreQuoteDetails: {
                    coreQuoteDetailsData: null,
                    errorMessage: castAction.errorMessage,
                },
                loading: false,
                error: true,
            }
        }
        case CORE_QUOTE_DETAILS_QUERY_RESET: {
            return {
                ...state,
                coreQuoteDetails: {
                    coreQuoteDetailsData: null,
                    errorMessage: null,
                },
            }
        }
        case CORE_QUOTE_DETAILS_QUERY_SUCCESS: {
            const castAction = action as CoreQuoteDetailsSuccessAction

            return {
                ...state,
                coreQuoteDetails: {
                    coreQuoteDetailsData: castAction.quote,
                    errorMessage: null,
                },
                loading: false,
                error: false,
            }
        }
        case LEGACY_QUOTE_DETAILS_QUERY_LOADING: {
            const castAction = action as SetLegacyQuoteDetailsQueryLoadingAction

            return {
                ...state,
                loading: castAction.loading,
            }
        }
        case LEGACY_QUOTE_DETAILS_QUERY_FAILURE: {
            const castAction = action as LegacyQuoteDetailsQueryFailureAction

            return {
                ...state,
                legacyQuoteDetails: {
                    errorMessage: castAction.errorMessage,
                },
                loading: false,
                error: true,
            }
        }
        case DRAWING_ANALYSIS_TAB_QUERY_FAILURE: {
            const castAction = action as drawingAnalysisTabFailureAction

            return {
                ...state,
                drawingAnalysisQuery: {
                    drawingAnalysisTabData: null,
                    errorMessage: castAction.errorMessage,
                },
                loading: false,
                error: true,
            }
        }
        case DRAWING_ANALYSIS_TAB_QUERY_SUCCESS: {
            const castAction = action as drawingAnalysisTabSuccessAction

            return {
                ...state,
                drawingAnalysisQuery: {
                    drawingAnalysisTabData: castAction.quote,
                    errorMessage: null,
                },
                loading: false,
                error: false,
            }
        }
        case CONFIG_MODAL_THREAD_FEEDBACK_ADD_REQ_QUERY_FAILURE: {
            const castAction =
                action as ConfigTabForFeedbackThreadsAddReqModalFailureAction

            return {
                ...state,
                detailsForFeedbackThreadsAddReqModalConfigTab: {
                    detailsForFeedbackThreadsAddReqModalConfigTabData: null,
                    errorMessage: castAction.errorMessage,
                },
                loading: false,
                error: true,
            }
        }
        case CONFIG_MODAL_THREAD_FEEDBACK_ADD_REQ_QUERY_SUCCESS: {
            const castAction =
                action as ConfigTabForFeedbackThreadsAddReqModalSuccessAction

            return {
                ...state,
                detailsForFeedbackThreadsAddReqModalConfigTab: {
                    detailsForFeedbackThreadsAddReqModalConfigTabData:
                        castAction.quote,
                    errorMessage: null,
                },
                loading: false,
                error: false,
            }
        }
        case IM_FEEDBACK_ADDREQ_UNCONFIGUREDCONFIGMODAL_TABS_QUERY_SUCCESS: {
            const castAction =
                action as IMFeedbackAddReqUnconfiguredConfigModalSuccessAction

            return {
                ...state,
                imAdditionalInformation: {
                    imAdditionalInformationData: castAction.quote,
                    errorMessage: null,
                },
                loading: false,
                error: false,
            }
        }
        case IM_FEEDBACK_ADDREQ_UNCONFIGUREDCONFIGMODAL_TABS_QUERY_FAILURE: {
            const castAction =
                action as IMFeedbackAddReqUnconfiguredConfigModalFailureAction

            return {
                ...state,
                imAdditionalInformation: {
                    imAdditionalInformationData: null,
                    errorMessage: castAction.errorMessage,
                },
                loading: false,
                error: true,
            }
        }
        default:
            return state
    }
}
